/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskResponseDto } from '../../models/core-project-task-response-dto';

export interface ProjectTasksControllerFindByProjectAndDate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The project ID.
 */
  projectId: string;

/**
 * The start date of the range (ISO string)
 */
  startDate: string;

/**
 * The end date of the range (ISO string)
 */
  endDate: string;
}

export function projectTasksControllerFindByProjectAndDate(http: HttpClient, rootUrl: string, params: ProjectTasksControllerFindByProjectAndDate$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerFindByProjectAndDate.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectId', params.projectId, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>;
    })
  );
}

projectTasksControllerFindByProjectAndDate.PATH = '/o2-core/project-tasks/{tenant}/project/{projectId}/by-date';
